import { render, staticRenderFns } from "./ProfileQuestions.vue?vue&type=template&id=3e06e00f&scoped=true&"
import script from "./ProfileQuestions.vue?vue&type=script&lang=js&"
export * from "./ProfileQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06e00f",
  null
  
)

export default component.exports